import cloneDeep from "lodash/cloneDeep";
import store from "~/lib/centralStore/index";

export function getStoreModuleContext(module) {
  let modulePath =
    module.lastIndexOf("/") == module.length - 1 ? module : module + "/";

  const moduleDetails = store._modulesNamespaceMap[modulePath];

  if (!moduleDetails)
    throw Error(
      `module ${module} not found in store, maybe either module is not created or module is not namespaced`
    );

  return moduleDetails.context;
}

export function preventMultipleActionDispatch(actionFn) {
  let isRunning = false;

  return async function () {
    if (isRunning) return;

    isRunning = true;

    let data = await actionFn
      .apply(this, arguments)
      .finally(() => (isRunning = false));

    return data;
  };
}

export function createResetableStore(options) {
  let initialState = options.state();

  return {
    ...options,
    state: () => cloneDeep(initialState),
    mutations: {
      ...options.mutations,
      resetState(state) {
        Object.assign(state, cloneDeep(initialState));
        if (options.mutations.resetState)
          options.mutations.resetState.apply(this, arguments);
      },
    },
    actions: {
      ...options.actions,
      async resetState({ commit }) {
        commit("resetState");
        if (options.actions.resetState)
          options.actions.resetState.apply(this, arguments);
      },
    },
  };
}

export async function watchAccessToken(callback) {
  await store.restored;

  store.watch((state) => state.auth.accsessToken, callback, {
    immediate: true,
  });
}